module.exports = __webpack_public_path__ + "static/media/image8.5d1338d0.jpg";